import { defineComponent as _defineComponent } from 'vue'
import CustomerRequiredDetailsForm from '@/components/CustomerRequiredDetailsForm.vue'
import selfServe from '@/store/modules/selfServe'
import user from '@/store/modules/user'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelfServeCustomerInformationV2',
  setup(__props) {

onMounted(() => {
  user.setIsQuoteFollowUpSMSEnabled(true)
})

const onCustomerUpdate = async (): Promise<void> => {
  await selfServe.createQuote()
  selfServe.nextStep()
}

return { __sfc: true,onCustomerUpdate, CustomerRequiredDetailsForm }
}

})